export default "__VITE_ASSET__658861af__"